import { render, staticRenderFns } from "./TasksListChatBot.vue?vue&type=template&id=5425de4a&scoped=true&"
import script from "./TasksListChatBot.vue?vue&type=script&lang=ts&"
export * from "./TasksListChatBot.vue?vue&type=script&lang=ts&"
import style0 from "./TasksListChatBot.vue?vue&type=style&index=0&id=5425de4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5425de4a",
  null
  
)

export default component.exports